import { render, staticRenderFns } from "./measurement.page.vue?vue&type=template&id=72c7c043&"
import script from "./measurement.page.vue?vue&type=script&lang=js&"
export * from "./measurement.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports